import {Component, ChangeDetectionStrategy} from '@angular/core';
import {RolesService} from '../roles-service';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyProfileComponent {

    isBackofficeAccount: boolean;

    constructor(rolesService: RolesService) {
        this.isBackofficeAccount = rolesService.isBackofficeAccount();
    }
}
